import React, { useState } from 'react';
import { withStyles } from '@material-ui/core/styles';

import MuiCollapse from '@material-ui/core/Collapse';
import MuiKeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import MuiKeyboardArrowUpIcon from '@material-ui/icons/KeyboardArrowUp';
import MuiTableHead from '@material-ui/core/TableHead';
import MuiBox from '@material-ui/core/Box';
import MuiTableRow from '@material-ui/core/TableRow';
import MuiTableCell from '@material-ui/core/TableCell';
import MuiTable from '@material-ui/core/Table';

import PayeeRow from './ReviewSplitPayeeRow';

const styles = () => ({
  collapsibleCell: {
    paddingBottom: 0,
    paddingTop: 0,
  },
  fullWidth: {
    width: '100%',
  },
  halfWidth: {
    width: '50%',
  },
  quarterWidth: {
    width: '25%',
  },
});

const Row = ({ track, classes, updateTrackPasthroughs, currentPassthroughs }) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const [passThroughs, setPassthroughs] = useState(currentPassthroughs || []);

  function togglePassthrough(splitId) {
    const updated = passThroughs.find(s => Number(s) === Number(splitId))
      ? passThroughs.filter(s => Number(s) !== Number(splitId))
      : [...passThroughs, splitId];

    setPassthroughs(updated);
    updateTrackPasthroughs({ trackId: track.id, passThroughSplitIds: updated });
  }

  return (
    <>
      <MuiTableRow onClick={() => setIsExpanded(!isExpanded)}>
        <MuiTableCell className={classes.fullWidth}>
          <strong>{track.title}</strong> -{' '}
          {track.trackParties
            .filter(tp => tp.roles.includes('MainArtist'))
            .map(tp => tp.party.full_name)
            .join(',')}
        </MuiTableCell>
        <MuiTableCell align="right">{track.isrc_code}</MuiTableCell>
        <MuiTableCell align="right">
          {isExpanded ? <MuiKeyboardArrowUpIcon /> : <MuiKeyboardArrowDownIcon />}
        </MuiTableCell>
      </MuiTableRow>
      <MuiTableRow>
        <MuiTableCell className={classes.collapsibleCell} colSpan={8}>
          <MuiCollapse in={isExpanded} timeout="auto" unmountOnExit>
            <MuiBox m={1}>
              <MuiTable>
                <MuiTableHead>
                  <MuiTableCell className={classes.halfWidth} />
                  <MuiTableCell className={classes.quarterWidth}>Split</MuiTableCell>
                  <MuiTableCell className={classes.quarterWidth}>Recoup Against</MuiTableCell>
                </MuiTableHead>
                {track.stakeholderTrackSplits.map(split => (
                  <PayeeRow
                    key={split.id}
                    split={split}
                    recoupsAgainst={!passThroughs.includes(split.id)}
                    togglePassthrough={togglePassthrough}
                  />
                ))}
              </MuiTable>
            </MuiBox>
          </MuiCollapse>
        </MuiTableCell>
      </MuiTableRow>
    </>
  );
};

export default withStyles(styles)(Row);
